import { render, staticRenderFns } from "./RouterOutView.vue?vue&type=template&id=47aa58f8"
import script from "./RouterOutView.vue?vue&type=script&lang=ts"
export * from "./RouterOutView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports